import React from "react";

const ImageDisplay = ({ imageName, alt = "Image" }) => {
	  const imagePath = `/images/${imageName}`;

	  return (
		      <div className="p-4">
		        <img src={imagePath} alt={alt} className="max-w-full h-auto rounded-xl shadow" />
		      </div>
		    );
};

export default ImageDisplay;

